import React from 'react';
import { BaseChart } from './BaseChart';

export interface LineChartProps {
  title?: string;
  categories: string[];
  series: {
    name: string;
    data: number[];
    color?: string;
    smooth?: boolean;
    areaStyle?: any;
    lineStyle?: any;
    [key: string]: any;
  }[];
  yAxisFormatter?: string | ((val: any) => string);
  tooltipFormatter?: string | ((params: any) => string);
  height?: number | string;
}

export const LineChart: React.FC<LineChartProps> = ({
  title,
  categories,
  series,
  yAxisFormatter,
  tooltipFormatter,
  height,
}) => {
  const option = {
    title: title ? { text: title, left: 'center' } : undefined,
    tooltip: tooltipFormatter ? { formatter: tooltipFormatter } : {},
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: categories,
    },
    yAxis: {
      type: 'value',
      axisLabel: yAxisFormatter ? { formatter: yAxisFormatter } : {},
    },
    legend: series.length > 1 ? { data: series.map(s => s.name) } : undefined,
    series: series.map(s => ({
      type: 'line',
      smooth: s.smooth !== false,
      symbolSize: 8,
      lineStyle: { width: 3, ...s.lineStyle },
      ...s,
    })),
  };

  return <BaseChart option={option} height={height} />;
};
